import reactComponentLoader from 'scripts/react-component-loader'

import { AlertMessageContainer } from '.'

reactComponentLoader(AlertMessageContainer, '[data-alert-message]')
